export enum DialogAction {
    OpenDialog = 'OPEN DIALOG',
    CloseDialog = 'CLOSE DIALOG',
    Error = 'ERROR',
    MINIMIZE = 'MINIMIZE',
    MAXIMIZE = 'MAXIMIZE',
}
